module.exports = __webpack_public_path__ + "img/eng-cloud-black.bd69657d.svg";